/* HMA EMALL V4 FINAL - cart, quantity, gallery, menu, variant and showcase behavior */
(function(){
  'use strict';

  async function addToCart(button){
    button.disabled=true;
    try{
      var r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(button.dataset.add),quantity:1}]})});
      if(!r.ok) throw new Error('Cart add failed');
      var c=await fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(x){return x.json()});
      document.querySelectorAll('[data-cart-count]').forEach(function(x){x.textContent=c.item_count});
      var t=document.querySelector('.hma-toast'); if(t){t.textContent='Added to cart ✓';t.style.display='block';setTimeout(function(){t.style.display='none'},1800)}
    }catch(err){window.location.href='/cart'}finally{button.disabled=false}
  }

  document.addEventListener('click',function(e){
    var add=e.target.closest('[data-add]'); if(add){e.preventDefault();addToCart(add);return;}
    var qty=e.target.closest('[data-qty-minus],[data-qty-plus]');
    if(qty){
      var wrap=qty.closest('[data-quantity-control]'), input=wrap&&wrap.querySelector('.qty-input'); if(!input)return;
      var min=parseInt(input.min||'1',10), max=input.max?parseInt(input.max,10):Infinity, value=parseInt(input.value||min,10); if(isNaN(value))value=min;
      input.value=qty.hasAttribute('data-qty-plus')?Math.min(value+1,max):Math.max(value-1,min);
      input.dispatchEvent(new Event('change',{bubbles:true})); return;
    }
    var nav=e.target.closest('[data-nav-toggle]');
    if(nav){
      e.preventDefault(); e.stopPropagation();
      var menu=nav.parentElement.querySelector('[data-nav-menu]'); if(!menu)return;
      var open=menu.classList.toggle('is-open'); nav.setAttribute('aria-expanded',open?'true':'false');
      document.querySelectorAll('[data-nav-menu].is-open').forEach(function(other){if(other!==menu){other.classList.remove('is-open');}});
      return;
    }
  });
  document.addEventListener('click',function(e){
    if(!e.target.closest('.nav')) document.querySelectorAll('[data-nav-menu].is-open').forEach(function(m){m.classList.remove('is-open')});
  });

  function initGallery(gallery){
    if(!gallery)return;
    var main=gallery.querySelector('[data-gallery-main-image]');
    var thumbs=Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    if(!main||!thumbs.length)return;
    var index=thumbs.findIndex(function(t){return t.classList.contains('is-active')}); if(index<0)index=0;
    function show(i){
  var items=Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-item]'));
  if(!items.length)return;

  index=(i+items.length)%items.length;

  items.forEach(function(item,n){
    var active=n===index;
    item.classList.toggle('is-active',active);
    item.style.display=active?'block':'none';
    if(!active){
      var video=item.querySelector('video');
      if(video)video.pause();
    }
  });

  thumbs.forEach(function(t,n){
    var active=n===index;
    t.classList.toggle('is-active',active);
    t.setAttribute('aria-current',active?'true':'false');
  });

  try{
    thumbs[index].scrollIntoView({
      behavior:'smooth',
      block:'nearest',
      inline:'center'
    });
  }catch(_){}
}
    thumbs.forEach(function(t,i){t.onclick=function(e){e.preventDefault();e.stopPropagation();show(i)}});
    var prev=gallery.querySelector('[data-gallery-prev]'), next=gallery.querySelector('[data-gallery-next]');
    if(prev)prev.onclick=function(e){e.preventDefault();e.stopPropagation();show(index-1)};
    if(next)next.onclick=function(e){e.preventDefault();e.stopPropagation();show(index+1)};
    var startX=null,startY=null;
    main.addEventListener('touchstart',function(e){if(e.touches[0]){startX=e.touches[0].clientX;startY=e.touches[0].clientY}},{passive:true});
    main.addEventListener('touchend',function(e){if(startX===null||!e.changedTouches[0])return;var dx=e.changedTouches[0].clientX-startX,dy=e.changedTouches[0].clientY-startY;startX=startY=null;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.2)show(dx<0?index+1:index-1)},{passive:true});
    main.addEventListener('keydown',function(e){if(e.key==='ArrowLeft')show(index-1);if(e.key==='ArrowRight')show(index+1)});
    show(index);
    var lb=document.getElementById('hmaLightbox'),lbImg=document.getElementById('hmaLightboxImg'),lbClose=document.getElementById('hmaLightboxClose'),lbPrev=document.getElementById('hmaLightboxPrev'),lbNext=document.getElementById('hmaLightboxNext');
    function openLightbox(i){
      if(!lb||!lbImg)return;
      var t=thumbs[i]||thumbs[0],src=t.getAttribute('data-full-src')||main.src,alt=t.getAttribute('data-alt')||'';
      lbImg.src=src;lbImg.alt=alt;lbImg.classList.remove('zoomed');
      lb.setAttribute('style','display:flex');
      document.body.style.overflow='hidden';
    }
    function closeLightbox(){
      if(!lb)return;
      lb.setAttribute('style','display:none');
      document.body.style.overflow='';
      if(lbImg)lbImg.classList.remove('zoomed');
    }
    main.style.cursor='zoom-in';

document.querySelectorAll('[data-gallery-main-image]').forEach(function(img){
  img.style.cursor='zoom-in';

  img.addEventListener('click',function(e){
    e.stopPropagation();

    var mediaItem=img.closest('[data-gallery-item]');
    var i=mediaItem ? Number(mediaItem.getAttribute('data-index')) : index;

    show(i);
    openLightbox(i);
  });
});
    if(lb)lb.addEventListener('click',function(e){if(e.target===lb||e.target.classList.contains('hma-lightbox-inner'))closeLightbox();});
    if(lbClose)lbClose.addEventListener('click',function(e){e.stopPropagation();closeLightbox();});
    if(lbImg)lbImg.addEventListener('click',function(e){e.stopPropagation();lbImg.classList.toggle('zoomed');});
    if(lbPrev)lbPrev.addEventListener('click',function(e){e.stopPropagation();var i=(index-1+thumbs.length)%thumbs.length;show(i);openLightbox(i);});
    if(lbNext)lbNext.addEventListener('click',function(e){e.stopPropagation();var i=(index+1)%thumbs.length;show(i);openLightbox(i);});
    document.addEventListener('keydown',function(e){
      if(!lb||lb.getAttribute('style')==='display:none')return;
      if(e.key==='Escape')closeLightbox();
      if(e.key==='ArrowLeft'){var i=(index-1+thumbs.length)%thumbs.length;show(i);openLightbox(i);}
      if(e.key==='ArrowRight'){var i=(index+1)%thumbs.length;show(i);openLightbox(i);}
    });
    var lbTouchX=null;
    if(lb){
      lb.addEventListener('touchstart',function(e){if(e.touches[0])lbTouchX=e.touches[0].clientX;},{passive:true});
      lb.addEventListener('touchend',function(e){if(lbTouchX===null||!e.changedTouches[0])return;var dx=e.changedTouches[0].clientX-lbTouchX;lbTouchX=null;if(Math.abs(dx)>45){var i=dx<0?(index+1)%thumbs.length:(index-1+thumbs.length)%thumbs.length;show(i);openLightbox(i);}},{passive:true});
    }
  }

  function initVariants(){
    document.querySelectorAll('[data-variant-select]').forEach(function(select){
      if(select.dataset.variantReady)return; select.dataset.variantReady='true';
      var price=select.closest('.product-info')&&select.closest('.product-info').querySelector('[data-product-price]');
      function update(){
        var opt=select.options[select.selectedIndex]; if(!opt)return;
        var current=price&&price.querySelector('.current-price'); if(current)current.textContent=opt.dataset.price||'';
        var old=price&&price.querySelector('.old'); var compare=opt.dataset.compare;
        if(old&&compare)old.textContent=compare;
        if(price)price.querySelector('.save-badge')?.remove();
        if(price&&compare&&compare!==opt.dataset.price&&opt.dataset.available==='true'){var s=document.createElement('span');s.className='save-badge';s.textContent='SALE';price.appendChild(s)}
      }
      select.addEventListener('change',update); update();
    });
  }

  function initShowcase(){
    document.querySelectorAll('[data-product-carousel]').forEach(function(root){
      if(root.dataset.carouselReady)return; root.dataset.carouselReady='true';
      var track=root.querySelector('[data-showcase-track]'), cards=track?Array.prototype.slice.call(track.children):[];
      if(!track||cards.length<2)return;
      var index=0, visible=1;
      function calc(){visible=window.innerWidth>=1100?4:window.innerWidth>=750?3:1}
      function render(){calc();var max=Math.max(0,cards.length-visible);if(index>max)index=0;var cardWidth=100/visible;track.style.transform='translateX(-'+(index*cardWidth)+'%)';var dots=root.querySelector('[data-showcase-dots]');if(dots){dots.innerHTML='';var pages=max+1;for(var i=0;i<pages;i++){var b=document.createElement('button');b.type='button';b.className='showcase-dot'+(i===index?' is-active':'');b.setAttribute('aria-label','Show product group '+(i+1));b.onclick=(function(n){return function(){index=n;render()}})(i);dots.appendChild(b)}}}
      var prev=root.querySelector('[data-showcase-prev]'),next=root.querySelector('[data-showcase-next]');
      if(prev)prev.onclick=function(){calc();var max=Math.max(0,cards.length-visible);index=index<=0?max:index-1;render()};
      if(next)next.onclick=function(){calc();var max=Math.max(0,cards.length-visible);index=index>=max?0:index+1;render()};
      render(); window.addEventListener('resize',render);
      var delay=parseInt(root.dataset.autoplay||'5000',10); if(isNaN(delay)||delay<3000)delay=5000;
      var timer=setInterval(function(){if(!document.hidden){calc();var max=Math.max(0,cards.length-visible);index=index>=max?0:index+1;render()}},delay);
      root.addEventListener('mouseenter',function(){clearInterval(timer)}); root.addEventListener('mouseleave',function(){timer=setInterval(function(){calc();var max=Math.max(0,cards.length-visible);index=index>=max?0:index+1;render()},delay)});
    });
  }

  function init(){document.querySelectorAll('[data-product-gallery]').forEach(initGallery);initVariants();initShowcase();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
